/* eslint-disable import/prefer-default-export */
import { ErrorResponse, SuccessResponse } from "services/SuccessResponse"
import axiosInstance, { isAxiosError } from "services/api"
import { CarbonWasteFactorItem } from "./types"

export const fetchWasteFactorizationValuesAsync = async (carbonCodeID: number) => {
  try {
    const response = await axiosInstance.get<
      SuccessResponse<CarbonWasteFactorItem[]> | ErrorResponse
    >(`/codetype-unit?filter=CUSTOM_LIST_ID||$eq||${carbonCodeID}`)
    return response.data
  } catch (err) {
    return isAxiosError(err)
  }
}

export const createCarbonValueForWasteFactorAsync = async (request: CarbonWasteFactorItem[]) => {
  try {
    const response = await axiosInstance.post<
      SuccessResponse<CarbonWasteFactorItem[]> | ErrorResponse
    >(`/codetype-unit/bulk`, { bulk: request })
    return response.data
  } catch (err) {
    return isAxiosError(err)
  }
}
